var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "camera-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        {
          staticClass: "filter-card",
          attrs: {
            shadow: "never",
            "body-style": { padding: "18px 22px 8px" },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "设备搜索" } },
                [
                  _c("el-input", {
                    staticClass: "keyword",
                    attrs: {
                      clearable: "",
                      placeholder: "编号 / 名称 / 位置 / 厂商",
                    },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleSearch($event)
                      },
                    },
                    model: {
                      value: _vm.searchForm.keywords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "keywords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.keywords",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "工地项目" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "全部项目",
                      },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.projectId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "projectId", $$v)
                        },
                        expression: "searchForm.projectId",
                      },
                    },
                    _vm._l(_vm.projectOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "设备状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部状态" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "待安装", value: "pending" },
                      }),
                      _c("el-option", {
                        attrs: { label: "使用中", value: "in_use" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已停用", value: "disabled" },
                      }),
                      _c("el-option", {
                        attrs: { label: "已拆除", value: "removed" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "在线状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部在线" },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.searchForm.onlineStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "onlineStatus", $$v)
                        },
                        expression: "searchForm.onlineStatus",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "在线", value: "online" },
                      }),
                      _c("el-option", {
                        attrs: { label: "离线", value: "offline" },
                      }),
                      _c("el-option", {
                        attrs: { label: "故障", value: "fault" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "metrics" }, [
        _c("div", [
          _c("span", [_vm._v("设备总数")]),
          _c("strong", [_vm._v(_vm._s(_vm.tableData.total))]),
          _c("small", [_vm._v("CAMERAS")]),
        ]),
        _c("div", { staticClass: "success" }, [
          _c("span", [_vm._v("当前页使用中")]),
          _c("strong", [_vm._v(_vm._s(_vm.inUseCount))]),
          _c("small", [_vm._v("IN USE")]),
        ]),
        _c("div", { staticClass: "online" }, [
          _c("span", [_vm._v("当前页在线")]),
          _c("strong", [_vm._v(_vm._s(_vm.onlineCount))]),
          _c("small", [_vm._v("ONLINE")]),
        ]),
        _c("div", { staticClass: "warning" }, [
          _c("span", [_vm._v("当前页待安装")]),
          _c("strong", [_vm._v(_vm._s(_vm.pendingCount))]),
          _c("small", [_vm._v("PENDING")]),
        ]),
        _c("div", { class: _vm.expiredCount ? "danger" : "" }, [
          _c("span", [_vm._v("当前页已到期")]),
          _c("strong", [_vm._v(_vm._s(_vm.expiredCount))]),
          _c("small", [_vm._v("EXPIRED")]),
        ]),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "title-row" },
            [
              _c("div", [
                _c("strong", [_vm._v("工地摄像头台账")]),
                _c("span", [
                  _vm._v("点击设备查看安装位置、服务有效期和授权策略"),
                ]),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", icon: "el-icon-refresh" },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
              on: { "row-click": _vm.openDetail },
            },
            [
              _c("el-table-column", {
                attrs: { label: "设备编号 / 名称", "min-width": "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [_vm._v(_vm._s(row.camera.deviceName))]),
                          _c("span", [_vm._v(_vm._s(row.camera.deviceNo))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "工地项目", "min-width": "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.project.projectName)),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(row.property.communityName) +
                                " · " +
                                _vm._s(row.customer.name)
                            ),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "安装位置", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(_vm._s(row.camera.installLocation || "--")),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "厂商 / 型号", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "two-line" }, [
                          _c("strong", [
                            _vm._v(_vm._s(row.camera.vendor || "未填厂商")),
                          ]),
                          _c("span", [
                            _vm._v(_vm._s(row.camera.model || "未填型号")),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "在线", width: "90", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.onlineTag[row.camera.onlineStatus],
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.onlineText(row.camera.onlineStatus))
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "服务到期", width: "155", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          { class: row.serviceExpired ? "expired" : "" },
                          [
                            _vm._v(
                              _vm._s(row.camera.serviceExpireTime || "未设置")
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "95", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTag[row.camera.status],
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(row.camera.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "210",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.openDetail(row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        row.camera.status === "pending"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.confirmAction(row, "install")
                                  },
                                },
                              },
                              [_vm._v("安装")]
                            )
                          : _vm._e(),
                        row.camera.status === "in_use"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.confirmAction(row, "disable")
                                  },
                                },
                              },
                              [_vm._v("停用")]
                            )
                          : _vm._e(),
                        row.camera.status === "disabled"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.confirmAction(row, "enable")
                                  },
                                },
                              },
                              [_vm._v("恢复")]
                            )
                          : _vm._e(),
                        ["in_use", "disabled"].includes(row.camera.status)
                          ? _c(
                              "el-button",
                              {
                                staticClass: "danger-text",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.confirmAction(row, "remove")
                                  },
                                },
                              },
                              [_vm._v("拆除")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.detail
        ? _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.drawerVisible,
                size: "560px",
                "custom-class": "camera-drawer",
                "with-header": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "drawer-head" },
                [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.detail.camera.deviceNo))]),
                    _c("h3", [_vm._v(_vm._s(_vm.detail.camera.deviceName))]),
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.detail.project.projectName) +
                          " · " +
                          _vm._s(
                            _vm.detail.camera.installLocation || "未填安装位置"
                          )
                      ),
                    ]),
                  ]),
                  _c(
                    "el-tag",
                    {
                      attrs: { type: _vm.statusTag[_vm.detail.camera.status] },
                    },
                    [_vm._v(_vm._s(_vm.statusText(_vm.detail.camera.status)))]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "drawer-body" }, [
                _c("div", { staticClass: "detail-grid" }, [
                  _c("div", [
                    _c("span", [_vm._v("工地客户")]),
                    _c("strong", [_vm._v(_vm._s(_vm.detail.customer.name))]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("在线状态")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.onlineText(_vm.detail.camera.onlineStatus))
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("厂商型号")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.detail.camera.vendor || "--") +
                          " / " +
                          _vm._s(_vm.detail.camera.model || "--")
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("视频流")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.detail.camera.hasStream
                            ? "已配置（密钥不回传）"
                            : "未配置"
                        )
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("安装时间")]),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.detail.camera.installedTime || "待安装")
                      ),
                    ]),
                  ]),
                  _c("div", [
                    _c("span", [_vm._v("服务到期")]),
                    _c(
                      "strong",
                      { class: _vm.detail.serviceExpired ? "expired" : "" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.detail.camera.serviceExpireTime || "未设置"
                          )
                        ),
                      ]
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "content-block" }, [
                  _c("span", [_vm._v("查看策略")]),
                  _c("p", [
                    _vm._v(
                      "角色 " +
                        _vm._s(
                          _vm.rolePolicy(_vm.detail.camera.accessPolicyMap)
                        ) +
                        " · 时段 " +
                        _vm._s(
                          _vm.hourPolicy(_vm.detail.camera.accessPolicyMap)
                        ) +
                        " · 水印 " +
                        _vm._s(
                          _vm.detail.camera.accessPolicyMap &&
                            _vm.detail.camera.accessPolicyMap.watermark ===
                              false
                            ? "关闭"
                            : "开启"
                        )
                    ),
                  ]),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "drawer-actions" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.drawerVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                  _vm.detail.camera.status === "pending"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmAction(_vm.detail, "install")
                            },
                          },
                        },
                        [_vm._v("确认安装")]
                      )
                    : _vm._e(),
                  _vm.detail.camera.status === "in_use"
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.confirmAction(_vm.detail, "offline")
                            },
                          },
                        },
                        [_vm._v("标记离线")]
                      )
                    : _vm._e(),
                  _vm.detail.camera.status === "in_use"
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.confirmAction(_vm.detail, "disable")
                            },
                          },
                        },
                        [_vm._v("停用")]
                      )
                    : _vm._e(),
                  _vm.detail.camera.status === "disabled"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmAction(_vm.detail, "enable")
                            },
                          },
                        },
                        [_vm._v("恢复使用")]
                      )
                    : _vm._e(),
                  ["in_use", "disabled"].includes(_vm.detail.camera.status)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "danger", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmAction(_vm.detail, "remove")
                            },
                          },
                        },
                        [_vm._v("拆除")]
                      )
                    : _vm._e(),
                  _vm.detail.camera.status === "pending"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "danger", plain: "" },
                          on: {
                            click: function ($event) {
                              return _vm.confirmAction(_vm.detail, "delete")
                            },
                          },
                        },
                        [_vm._v("删除")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("SITE CAMERA & LIVE MONITOR")]),
        _c("h2", [_vm._v("工地摄像头与看监控")]),
        _c("p", [
          _vm._v(
            "绑定设备、确认安装、管理在线状态和服务有效期，授权业主与项目成员查看现场监控。"
          ),
        ]),
      ]),
      _c("div", { staticClass: "hero-badges" }, [
        _c("b", [_vm._v("设备绑定")]),
        _c("b", [_vm._v("安装授权")]),
        _c("b", [_vm._v("安全播放")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }